'use client';

import React from 'react';
import { Icons } from '@/assets/icons';
import { ProfileImage } from '@/shared/components/profile-image';
import { cn } from '@/shared/utils/style/cn';
import Sidebar from '@/shared/components/layout/sidebar';
import { SidebarProvider, useSidebar } from '@/shared/providers/sidebar';

export default function MainHeader({ title, className }: { title?: string; className?: string }) {
  return (
    <SidebarProvider>
      <header
        id="header"
        className={cn(
          'text-gray90 fixed top-0 z-10 flex h-[48px] w-full max-w-[600px] items-center gap-[8px] bg-inherit px-[16px]',
          className,
        )}
      >
        <MainHeaderContent title={title} />
      </header>
      <Sidebar />
    </SidebarProvider>
  );
}

function MainHeaderContent({ title }: { title?: string }) {
  const { toggleSidebar } = useSidebar();

  return (
    <>
      <Icons.Header.Menu
        width={24}
        height={24}
        className="cursor-pointer"
        onClick={toggleSidebar}
      />
      <div className="flex-1">
        {title ? (
          <h1 className="typo-heading-1 line-clamp-1 overflow-hidden font-medium text-ellipsis">
            {title}
          </h1>
        ) : (
          <Icons.MediPro width={138} height={24} />
        )}
      </div>
      <div className="flex items-center gap-[12px]">
        <Icons.Header.Noti width={24} height={24} className="cursor-pointer" />
        <ProfileImage className="size-[24px] cursor-pointer" imagePath={undefined} />
      </div>
    </>
  );
}
